import { useEffect, useState } from 'react';

// The desktop top bar (Layout.desktop) shows the address other devices on the
// same Wi-Fi open — development only, from /__devinfo in src/setupProxy.js.
// On the website and in the APK there is no dev server, so local stays null
// and nothing is shown. (API / server details are deliberately not shown.)
export function useHostInfo() {
  const [local, setLocal] = useState(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return undefined;
    let alive = true;
    fetch('/__devinfo')
      .then(r => (r.ok ? r.json() : null))
      .then(d => {
        if (!alive || !d) return;
        const ip = (d.ips || []).find(x => !x.virtual) || (d.ips || [])[0];
        setLocal(ip ? `http://${ip.address}:${d.port}` : null);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return { local };
}
